export const section1 = [
  {
    id: 0,
    path: "/images/sequence/section-1/1.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 1,
    path: "/images/sequence/section-1/2.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 2,
    path: "/images/sequence/section-1/3.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 3,
    path: "/images/sequence/section-1/4.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 4,
    path: "/images/sequence/section-1/5.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 5,
    path: "/images/sequence/section-1/6.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 6,
    path: "/images/sequence/section-1/7.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 7,
    path: "/images/sequence/section-1/8.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 8,
    path: "/images/sequence/section-1/9.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 9,
    path: "/images/sequence/section-1/10.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 10,
    path: "/images/sequence/section-1/11.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 11,
    path: "/images/sequence/section-1/12.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 12,
    path: "/images/sequence/section-1/13.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 13,
    path: "/images/sequence/section-1/14.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 14,
    path: "/images/sequence/section-1/15.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 15,
    path: "/images/sequence/section-1/16.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 16,
    path: "/images/sequence/section-1/17.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 17,
    path: "/images/sequence/section-1/18.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 18,
    path: "/images/sequence/section-1/19.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 19,
    path: "/images/sequence/section-1/20.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 20,
    path: "/images/sequence/section-1/21.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 21,
    path: "/images/sequence/section-1/22.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 22,
    path: "/images/sequence/section-1/23.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 23,
    path: "/images/sequence/section-1/24.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 24,
    path: "/images/sequence/section-1/25.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 25,
    path: "/images/sequence/section-1/26.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 26,
    path: "/images/sequence/section-1/27.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 27,
    path: "/images/sequence/section-1/28.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 28,
    path: "/images/sequence/section-1/29.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 29,
    path: "/images/sequence/section-1/30.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 30,
    path: "/images/sequence/section-1/31.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 31,
    path: "/images/sequence/section-1/32.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 32,
    path: "/images/sequence/section-1/33.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 33,
    path: "/images/sequence/section-1/34.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 34,
    path: "/images/sequence/section-1/35.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 35,
    path: "/images/sequence/section-1/36.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 36,
    path: "/images/sequence/section-1/37.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 37,
    path: "/images/sequence/section-1/38.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 38,
    path: "/images/sequence/section-1/39.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 39,
    path: "/images/sequence/section-1/40.jpg",
    loaded: false,
    asset: null
  }
]
